import { render, staticRenderFns } from "./fbaVerify.vue?vue&type=template&id=8f7f8ba8&"
import script from "./fbaVerify.vue?vue&type=script&lang=js&"
export * from "./fbaVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f7f8ba8')) {
      api.createRecord('8f7f8ba8', component.options)
    } else {
      api.reload('8f7f8ba8', component.options)
    }
    module.hot.accept("./fbaVerify.vue?vue&type=template&id=8f7f8ba8&", function () {
      api.rerender('8f7f8ba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/fbaVerify.vue"
export default component.exports